var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login-wrap"
  }, [_vm.wayType === 'email' ? _c('div', {
    staticClass: "email-inner"
  }, [_c('notice-txt', {
    attrs: {
      "txt": "".concat(_vm.$t(_vm.$loginLangPrefix('userSign.reged'), {
        name: _vm.name
      }))
    }
  }), _vm._v(" "), _c('password-input', {
    attrs: {
      "hide": "true",
      "log": "log"
    },
    on: {
      "changePassword": _vm.changePasswordHandle,
      "changePasswordError": _vm.changePasswordErrorHandle,
      "btnSure": _vm.keyVal
    }
  }), _vm._v(" "), _c('error-tip', {
    attrs: {
      "txt": _vm.passwordError
    }
  }), _vm._v(" "), _vm.codeState ? _c('code-input', {
    ref: "codeInputRef",
    attrs: {
      "name": _vm.name
    },
    on: {
      "changeCode": _vm.changeCodeHandle,
      "changeCodeError": _vm.changeCodeErrorHandle,
      "btnSure": _vm.keyVal
    }
  }) : _vm._e(), _vm._v(" "), _vm.codeState ? _c('error-tip', {
    attrs: {
      "txt": _vm.codeError
    }
  }) : _vm._e(), _vm._v(" "), _c('button-wrap', {
    attrs: {
      "has": _vm.actBtn,
      "cover": _vm.cover,
      "txt": _vm.$t(_vm.$loginLangPrefix('userSign.signIn'))
    },
    on: {
      "btnSure": _vm.keyVal
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "have",
    on: {
      "click": function click($event) {
        return _vm.showForget();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.forget'))))])], 1) : _vm._e(), _vm._v(" "), _vm.wayType === 'm-email' ? _c('div', {
    staticClass: "memail-inner"
  }, [_c('title-txt', {
    attrs: {
      "txt": _vm.$t(_vm.$loginLangPrefix('userSign.signIn'))
    }
  }), _vm._v(" "), _c('notice-txt', {
    attrs: {
      "mb": "mb",
      "txt": "".concat(_vm.$t(_vm.$loginLangPrefix('userSign.reged'), {
        name: _vm.name
      }))
    }
  }), _vm._v(" "), _c('password-input', {
    attrs: {
      "hide": "true",
      "log": "log",
      "mb": "mb"
    },
    on: {
      "changePassword": _vm.changePasswordHandle,
      "changePasswordError": _vm.changePasswordErrorHandle
    }
  }), _vm._v(" "), _c('error-tip', {
    attrs: {
      "txt": _vm.passwordError,
      "mb": "mb"
    }
  }), _vm._v(" "), _vm.codeState ? _c('code-input', {
    ref: "codeInputRef",
    attrs: {
      "name": _vm.name,
      "mb": "mb"
    },
    on: {
      "changeCode": _vm.changeCodeHandle,
      "changeCodeError": _vm.changeCodeErrorHandle
    }
  }) : _vm._e(), _vm._v(" "), _vm.codeState ? _c('error-tip', {
    attrs: {
      "txt": _vm.codeError,
      "mb": "mb"
    }
  }) : _vm._e(), _vm._v(" "), _c('button-wrap', {
    attrs: {
      "mb": "mb",
      "has": _vm.actBtn,
      "cover": _vm.cover,
      "txt": _vm.$t(_vm.$loginLangPrefix('userSign.signIn'))
    },
    on: {
      "btnSure": _vm.keyVal
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "have mb",
    on: {
      "click": function click($event) {
        return _vm.showForget();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.forget'))))])], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };